import { render } from "./subjecthis.vue?vue&type=template&id=c23966da&scoped=true"
import script from "./subjecthis.vue?vue&type=script&lang=js"
export * from "./subjecthis.vue?vue&type=script&lang=js"

import "./subjecthis.vue?vue&type=style&index=0&id=c23966da&lang=scss&scoped=true"
import "./subjecthis.vue?vue&type=style&index=1&id=c23966da&lang=scss"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c23966da"]])

export default __exports__